import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import RootComponent from 'core/RootComponents'
import { useAuth } from 'quantic/hooks'
import { Navbar, Footer } from 'components'
import Router from 'core/Router'

function App() {
  const { isAuthenticated } = useAuth()

  return (
    <BrowserRouter>
      {isAuthenticated && <Navbar />}
      <Router />
      {isAuthenticated && <Footer />}
    </BrowserRouter>
  )
}

export default () => (
  <RootComponent>
    <App />
  </RootComponent>
)
